import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { OnyxModalService } from '@onyx/angular';
import { AddFleetModalComponent } from '../components/add-fleet-modal/add-fleet-modal.component';
import { FleetRoute } from '../enums/fleet-route';
import { FleetRouterStateKey } from '../enums/fleet-router-state-key';

export const addFleetGuard: CanActivateFn = () => {
  const router = inject(Router);
  const modalService = inject(OnyxModalService);

  const state = router.currentNavigation()?.extras?.state;
  const category = state?.[FleetRouterStateKey.CATEGORY];
  const type = state?.[FleetRouterStateKey.TYPE];

  if (category && type !== undefined) return true;

  modalService.open(AddFleetModalComponent);
  return router.parseUrl(FleetRoute.FLEET_LIST);
};
